<template>
    <counsel-card-row label="첨부파일">
        <div class="form-file-box">
            <v-row align="center" class="row--small">
                <v-col cols="12" md="11">
                    <v-file-input v-model="temp" dense hide-details outlined />
                </v-col>
                <v-col cols="12" md="1">
                    <v-btn block outlined color="primary" @click="addFile">첨부</v-btn>
                </v-col>
            </v-row>
            <v-chip-group v-model="value" multiple>
                <v-chip v-for="(file, i) in value" :key="i" :value="file"><span>{{ file.name }}</span><v-icon small>mdi-close</v-icon></v-chip>
            </v-chip-group>
        </div>
    </counsel-card-row>
</template>

<script>
import counselCardRow from "./counsel-card-row.vue";
export default {
    components: { counselCardRow },
    props: ["value"],
    data() {
        return { temp: null };
    },
    methods: {
        addFile() {
            if (this.temp) {
                this.$emit("input", [...this.value, this.temp]);
                this.temp = null;
            } else alert("파일을 추가하세요.");
        },
    },
};
</script>

<style></style>
